import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../services/auth-state.service';
import { CaptureRecoveryService } from '../../features/home/services/capture-recovery.service';

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthStateService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return true;
  }

  // Coming back after Android killed the app mid-capture: go straight to that survey
  // (no /home flash) so the capture can be resumed.
  return inject(CaptureRecoveryService).resumeUrlTree() ?? router.createUrlTree(['/home']);
};
